import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import styled from 'styled-components'
import {BorderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/BorderInput'
import {ColorInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/ColorInput'
import {PaddingInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/PaddingInput'
import {
  DefaultBlockMobileConfigType,
  DefaultBlockMobileConfigValues,
} from 'TemplateEditor/Layout/Blocks/DefaultBlockMobileConfig'

export type Padding = {
  top: number
  bottom: number
  left: number
  right: number
}

export type Border = {
  color: string | null
  width: number
  radius: number
}

export type Position = {
  vertical:
    | 'center'
    | 'end'
    | 'start'
    | 'space-evenly'
    | 'space-between'
    | 'space-around'
  horizontal: 'center' | 'end' | 'start'
}

export type TextAlign = 'left' | 'right' | 'center' | 'justify'

export type DefaultBlockConfigType = {
  padding: Padding
  background: string | null
  visible: boolean
  /** If non-empty, only attendees with one of these `event_tickets.id` see the block when `visible` is true. */
  visible_ticket_ids?: number[]
  visibility: 'all' | 'desktop' | 'mobile'
  border: Border
  mobile: DefaultBlockMobileConfigType
}

export const DefaultBlockConfigValues = (): DefaultBlockConfigType => {
  return {
    padding: {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    background: null,
    visible: false,
    visible_ticket_ids: [],
    visibility: 'all',
    border: {
      color: '#ffffff',
      width: 0,
      radius: 0,
    },
    mobile: {...DefaultBlockMobileConfigValues},
  }
}

export function DefaultBlockConfig(props: {values: any; setFieldValue: any}) {
  const {t} = useI18n()
  const {values, setFieldValue} = props

  return (
    <>
      <StyledTitle>{t('templateEditor.bordersTitle')}</StyledTitle>

      <BorderInput
        value={values.border}
        name={'border'}
        label={t('templateEditor.bordersFieldLabel')}
        setFieldValue={setFieldValue}
      />

      <StyledTitle>{t('templateEditor.sectionBackground')}</StyledTitle>
      <ColorInput
        value={values.background ?? ''}
        name={'background'}
        label={t('templateEditor.backgroundColorLabel')}
        setFieldValue={setFieldValue}
      />
      <StyledTitle>{t('templateEditor.paddingTitle')}</StyledTitle>

      <PaddingInput
        value={values.padding}
        name={'padding'}
        label={t('templateEditor.paddingFieldLabel')}
        setFieldValue={setFieldValue}
        max={500}
        min={0}
      />
    </>
  )
}

export const StyledTitle = styled.div`
  font-weight: bold;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 15px;
  color: var(--clr-common-white);
  background: var(--clr-gradient-1);
`
